import "./UsersRating.less";

interface UsersRatingsProps {
   rates: number[];
}

export const UsersRatings = ({ rates }: UsersRatingsProps) => {
   const rateMap: Record<number, number> = {
      5: 0,
      4: 0,
      3: 0,
      2: 0,
      1: 0,
   };

   for (const num of rates) {
      if (rateMap[num] !== undefined) {
         rateMap[num]++;
      }
   }

   const maxValue = Math.max(...Object.values(rateMap));

   return (
      <div className="users-ratings">
         {Object.entries(rateMap).map(([rating, count]) => {
            const percentage = (count / maxValue) * 100;

            return (
               <div key={rating} className="users-ratings__opinion-row">
                  <span className="users-ratings__rating-label">{rating}</span>
                  <div className="users-ratings__bar-container">
                     <div
                        className="users-ratings__bar-container--fill"
                        style={{ width: `${percentage}%` }}
                     ></div>
                  </div>
               </div>
            );
         })}
      </div>
   );
};
